import { render, staticRenderFns } from "./sorticon.vue?vue&type=template&id=c89ac27a&scoped=true&"
var script = {}
import style0 from "./sorticon.vue?vue&type=style&index=0&id=c89ac27a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89ac27a",
  null
  
)

export default component.exports